(() => {
    class Model {
        constructor(data) {
            this.data = data;
        }

        /* INTERFACE: It only set an interface for heritage */
        get get () {
            return this.adaptor();
        }

        /**
         * Analog to "Object.defineProperty"
         * This method can be useful to keep relationship with another API without
         * calling the API yet, only as a reference.
         * Good example is the Product => Offer relation
         * @param name
         * @param get
         * @return {Model}
         */
        setDynamicProperty(name, get) {
            const item = this.data;
            if (item[name] === undefined) {
                Object.defineProperty(item, name, { get: get, configurable: true });
            }
            return this;
        }

        /* INTERFACE: It only set an interface for heritage */
        adaptor() {
            return this.data;
        }
    }
    App.Entities.Model = Model;
})();
